export * from "./src/http-loader";



//////////////////
// WEBPACK FOOTER
// ./~/@ngx-translate/http-loader/index.js
// module id = 459
// module chunks = 0